export default __webpack_public_path__ + "static/dmarc360-platform-feature-c15b263c2fd949be4a051a1d679c729e.png";